export default __webpack_public_path__ + "static/media/programming.21eee78a.png";